module.exports = __webpack_public_path__ + "60088697dc90cb6fb1fb61fa14df3ab8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/pages/layout/base/images/bindo-dashboard-logo.png
 ** module id = 1307
 ** module chunks = 0
 **/